import { movies } from "@/mocks/movies";
import MovieCard from "./MovieCard";

export default function LatestGrid() {
  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 8);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新影视推荐</h2>
          <p className="text-sm text-foreground-500 mt-1">持续更新的影视解析内容，带你第一时间读懂新作</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {latest.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}